import React from 'react';
import {List, useRedirect, useTranslate} from 'react-admin';
import {Box, Typography} from '@mui/material';
import {t} from '../themes/statamicTokens';
import StatamicListPage from '../components/statamic/StatamicListPage';
import MonoChip from '../components/statamic/MonoChip';
import {formatDateTime} from '../lib/dates';

const TextCell = ({value}) => (
    <Typography
        sx={{
            fontSize: `${t.type.body.size}px`,
            color: value ? t.color.text.secondary : t.color.text.muted,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}
    >
        {value ?? '—'}
    </Typography>
);

const MessagePreview = ({value}) => (
    <Typography
        sx={{
            fontSize: `${t.type.caption.size}px`,
            fontFamily: t.font.mono,
            color: t.color.text.primary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}
    >
        {value ?? '—'}
    </Typography>
);

const AppErrorsListStatamicInner = () => {
    const redirect = useRedirect();
    const translate = useTranslate();

    const columns = [
        {
            key: 'date', label: translate('Date'), sortable: true, sortField: 'date', width: 170,
            render: (r) => <TextCell value={formatDateTime(r.date)}/>,
        },
        {
            key: 'platform', label: 'Platform', width: 110,
            render: (r) => r.platform
                ? <MonoChip>{r.platform}</MonoChip>
                : <TextCell value={null}/>,
        },
        {
            key: 'screen', label: 'Screen', width: 160,
            render: (r) => <TextCell value={r.screen}/>,
        },
        {
            key: 'action', label: 'Action', width: 160,
            render: (r) => <TextCell value={r.action}/>,
        },
        {
            key: 'message', label: 'Message',
            render: (r) => <MessagePreview value={r.message}/>,
        },
    ];

    return (
        <StatamicListPage
            title={translate('App Errors')}
            subtitle="Client-side errors reported from the mobile and web apps"
            columns={columns}
            onRowClick={(record) => redirect('show', 'errors', record.id)}
        />
    );
};

const AppErrorsListStatamic = (props) => (
    <List
        {...props}
        sort={{field: 'id', order: 'DESC'}}
        perPage={25}
        actions={false}
        pagination={false}
        component={Box}
        sx={{
            backgroundColor: t.color.page,
            '& .RaList-main': {backgroundColor: t.color.page},
        }}
    >
        <AppErrorsListStatamicInner/>
    </List>
);

export default AppErrorsListStatamic;
